export default class AuthTokenError extends Error {
    constructor() {
        super('Auth token is not available.');
    }
}
